export const TERMINAL_TELEMETRY_EVENT = "ano:terminal-telemetry";

export type TerminalTelemetryEventName =
  | "agent_turn_rendered"
  | "agent_approval_shown"
  | "agent_approval_decision"
  | "agent_card_rendered"
  | "agent_card_action_clicked"
  | "agent_link_routed_in_app"
  | "agent_link_opened_external"
  | "agent_response_contract_violation";

export interface TerminalTelemetryEventDetail {
  name: TerminalTelemetryEventName;
  payload: Record<string, unknown>;
  ts: number;
}

export function emitTerminalTelemetry(
  name: TerminalTelemetryEventName,
  payload: Record<string, unknown> = {},
): void {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent<TerminalTelemetryEventDetail>(TERMINAL_TELEMETRY_EVENT, {
      detail: {
        name,
        payload,
        ts: Date.now(),
      },
    }),
  );
}
